import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from "@angular/router";

export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (
      (this.samePathPrefix("inventory/:id", future, curr) && future.params.id !== curr.params.id) ||
      (this.samePathPrefix("sell/saleDoc/:id", future, curr) && future.params.id !== curr.params.id)
    ) {
      return false;
    }
    return super.shouldReuseRoute(future, curr);
  }

  private samePathPrefix(prefix: string, future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig?.path.startsWith(prefix) && curr.routeConfig?.path.startsWith(prefix);
  }
}
